import React from 'react';
import logo from '@/assets/logo2.png';
import styles from './index.module.scss';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  children?: React.ReactNode;
}

const LoginMain: React.FC<Props> = ({ children, title }) => {
  return (
    <section className={styles.loginPage}>
      <main className={styles.container}>
        <div className={styles.contentWrapper}>
          <img className={styles.logo} src={logo} alt="logo" />
          <h3 className={styles.title}>{title}</h3>
          {children}
        </div>
      </main>

      <footer className={styles.footer}>
        <p>@2025 Nonasea</p>
        <p>
          Power by Nonasea |{' '}
          <Link className={styles.link} to="/policy">
            Prvacy policy
          </Link>
        </p>
      </footer>
    </section>
  );
};

export default LoginMain;
